import { useEffect, useState, useContext } from "react";
import BoxTitle from "../../box/title/BoxTitle";
import BoxSubTitle from "../../box/subTitle/BoxSubTitle";
import BoxEntity from "../../box/entity/BoxEntity";
import CustomSlider from "../../customSlider/CustomSlider";

import { LoadingDot } from "../../UI/spinners/LoadingSpinners";
import { getCategoryInfos } from "../../Map/utils";
import { MeteoInfoDataContext } from "../../../hooks/context";

const Meteor = ({ typeId }) => {
  const [categoryData, setCategoryData] = useState(null);
  const { meteoInfoData, loading } = useContext(MeteoInfoDataContext);

  useEffect(() => {
    setCategoryData(getCategoryInfos(typeId));
  }, []);

  return (
    <>
      {loading && <LoadingDot />}
      <BoxTitle
        icon={`im ${categoryData?.icon}`}
        title={categoryData?.title.toUpperCase()}
        link={`/map?typeId=${typeId}`}
        infoContext={categoryData?.tooltip}
        element={
          <i
            id="draggable"
            className="im im-icon-Double-Tap"
            style={{ fontSize: "32px", minWidth: "32px", cursor: "pointer" }}
          />
        }
        id={typeId}
      />
      {meteoInfoData?.length > 0 && (
        <CustomSlider>
          {meteoInfoData?.map((infoItem, index) => {
            return (
              <div key={index}>
                <BoxSubTitle>{infoItem.sensor_address}</BoxSubTitle>
                {infoItem.details.map((infoDetail, index) => {
                  return (
                    <BoxEntity
                      key={index}
                      icon={`https://alexandria.smartiscity.gr/gallery/vars/Big/${infoDetail.sensorvar_icon}`}
                      content={infoDetail.sensorvar_description}
                      value={`${parseInt(infoDetail.measurement).toFixed(2)} ${
                        infoDetail.sensorvar_unit
                      }`}
                      date={infoDetail.date_insert}
                    />
                  );
                })}
              </div>
            );
          })}
        </CustomSlider>
      )}
      {meteoInfoData?.length === 0 && (
        <p
          style={{
            fontWeight: "600",
            fontSize: "14px",
            paddingTop: "10px",
            color: "#333",
          }}
        >
          Αδηναμία λύψης δεδομένων λόγο προβλήματος
        </p>
      )}
    </>
  );
};

export default Meteor;
